export const SEARCH_BAR_MARGIN_TOP = 6;
export const SEARCH_BAR_MARGIN_BOTTOM = 6;
